import { ReactNode } from 'react';

import { Breadcrumbs } from 'types/breadcrumbs';

import Navbar, { NavlinkKey } from '../Navbar';

import './Page.scss';

interface PageProps {
  activeNavlink?: NavlinkKey;
  padding?: boolean;
  className?: string;
  children: ReactNode;
  breadcrumbs?: Breadcrumbs;
}

export default function Page({ activeNavlink, padding = true, className = '', children, breadcrumbs }: PageProps) {
  return (
    <>
      <Navbar activeNavlink={activeNavlink} breadcrumbs={breadcrumbs} />
      {/* Fill the space that is under navbar so part of page doesn't get hidden under it. */}
      <div className="navbar-space-filler" />
      <div className={`page ${padding ? 'padding' : ''} ${className}`}>{children}</div>
    </>
  );
}
